import { useEffect } from "react";
import TourUploadButton from "./TourUploadButton";
import AlertMessage from "../Shared/AlertMessage";
import { triggerAnalyticsEvent } from "../../helpers";
import Say from "../../languages/Say";
import { getPhrase, PhraseKey } from "../../languages";

export const TourPhotoReject = (props) => {
  const { onRetake, photoModerationParams, children } = props;
  const { photoModerationError, photoDenyReasons, photoModResponse } = photoModerationParams;
  const errorPhraseKey: PhraseKey = photoModerationError
    ? "errors.service_error"
    : "photo_step.photo_reject_message";

  useEffect(() => {
    const rejectReasonsString = photoDenyReasons?.join(", ");
    const results = photoModResponse?.photoModeration?.results || "Reject";

    const errorMessageText = getPhrase(errorPhraseKey);
    triggerAnalyticsEvent("flex_checkout_photo_moderation_error", {
      event_action: `${results}:reject`,
      event_category: "flex_photo_upload_error",
      event_label: `${errorMessageText}:${rejectReasonsString}`,
      error_message: `${errorMessageText}:${rejectReasonsString}`
    });
  }, [errorPhraseKey, photoModerationError, photoModResponse]);

  return (
    <div className="tour-photo__reject photo-step">
      {children}
      <AlertMessage alertType="danger" visible={true}>
        Your photo could not be added.
      </AlertMessage>
      <p className="tour-photo__reject-message">
        <Say phrase={errorPhraseKey} />
      </p>
      <div className="post-checkout-flow__controls single-button">
        <TourUploadButton
          classList="btn btn-primary photo"
          handleFileChange={onRetake}
          clickEventActionKey="photo_upload_retake_hard_reject">
          <Say phrase="photo_step.photo_retake_cta" />
        </TourUploadButton>
      </div>
    </div>
  );
};

export default TourPhotoReject;
